



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppSelector from '@/components/AppSelector.vue'
import { ICarrierProductInsuranceInput } from '@/modules/CarrierProduct/interfaces/carrier-product-form'
import { documentDeliveryValues, quoteViaValues, bindIssueViaValues } from '@/modules/Carrier/helpers/carrier'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppPhoneInput
  }
})
export default class CarrierProductFormAdditional extends Vue {
  @Prop({ type: Object as () => ICarrierProductInsuranceInput }) value!: ICarrierProductInsuranceInput

  deliveryOptions = documentDeliveryValues
  quoteViaOptions = quoteViaValues
  bindIssueViaOptions = bindIssueViaValues

  downloadsOptions = ['Yes', 'No']

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
